import React from 'react';


//This will be the service for checking for RPO Questions in the different adapters
//Will also be the service for operating on those RPO Questions from different adapters

/**
 * Service used for operating and handling RPO Questions and Selections for the SPS2 Info front end
 *
 * @author Ethan Jones
 */
class RpoService{

    /**
     * Method used for checking if the selected controller/function/method selection has RPO questions that need
     * selecting for NAO Vins and GME Vins. Gspas Vins use Question and Answer, not RPO.
     *
     * @param method The method selected by the user on the front end. Method contains the RPO question if it exists
     * @param adapterType   The adapter type associated with the vin. Different adapters have different structures
     * @param serviceHandlerWsp Handler used when NAOVin
     * @param serviceHandlerDth Handler used when GMEVin
     * @returns {Promise<void>}
     */
    async checkForRpo(method, adapterType, serviceHandlerWsp, serviceHandlerDth){
        if(adapterType === "NAOVin"){
            await this.checkForRpoWsp(method, serviceHandlerWsp)
        }
        else if(adapterType === "GMEVin"){
            await this.checkForRpoDth(method, serviceHandlerDth)
        }
        else{

        }
    }

    /**
     * Method used for checking if the selected method for NAOVin contains RPO Questions
     *
     * @param method Selected method by user
     * @param serviceHandlerWsp Handler for NAOVin Rpo Selection
     * @returns {Promise<void>}
     */
    async checkForRpoWsp(method, serviceHandlerWsp){
        if(method[1] === null){

        }
        else if(method[1].options.length === 1){
            let label = await method[1].options[0].label
            let postRpoQuestions = Object.keys(method[1].options[0].selections).map(
                key => key
            )
            await serviceHandlerWsp(postRpoQuestions, label)
        }
        else{

        }
    }

    /**
     * Method used for checking if the selected method for GMEVin contains RPO Questions
     *
     * @param method Selected method by user
     * @param serviceHandlerWsp Handler for GMEVin Rpo Selection
     * @returns {Promise<void>}
     */
    async checkForRpoDth(method, serviceHandlerDth){
        if(method[1] === null){
            return
        }
        let location = {top:-75, left:550}
        let locations = [location]
        let addRpoQ = []
        addRpoQ.push(method[1].currentOption)
        if(method[1].currentOption.selections.length !== 0){
            let rpoQuestions = []
            let composite = method[1]
            await method[1].currentOption.selections.map(data =>{
                rpoQuestions.push(data)
            })
            await serviceHandlerDth(rpoQuestions, composite, addRpoQ, locations)
        }
    }

    /**
     * Method used for updating the list containing the rpo selections being displayed to the front end
     * @param nextComposite Next composite to be pushed onto the list
     * @param additionalComposites  List of RPO Composites
     * @returns {Promise<*>}
     */
    async updateRpoComposites(nextComposite, additionalComposites){
        let optionComposites = additionalComposites
        optionComposites.push(nextComposite)
        return optionComposites
    }

    /**
     * Method used removing rpo questins from the list used to render them. Important for when a user accidentally
     * clicks or backtracks on a selection. We do not want to break the front end or send incorrect data to the backend
     *
     * @param selectedIndex Index of the rpo question selected
     * @param items list of rpo questions that is used for rendering
     *
     * @returns {Promise<*>}
     */
    async removeListTail(selectedIndex, items){
        items.length =  await selectedIndex + 1
        return items;
    }

    //---------Below this, need to make way and make functions used for handling the selections of RPO Questions aka
    // migrate code

    async updateDthRpoStateObjects(stateObject,selection, selectionIndex, questionIndex, presenterHandler, rpoListHandler,
                                   vinDecodeRpoHandler, rpoRenderListHandler, rpoReselectHandler){
        await presenterHandler()
        let isReselect = false
        if(stateObject.additionalRpoQuestions.length > questionIndex+1){
            stateObject.additionalRpoQuestions = await this.removeListTail(questionIndex, stateObject.additionalRpoQuestions)
            stateObject.additionalRpoLocations = await this.removeListTail(questionIndex, stateObject.additionalRpoLocations)
            stateObject.additionalRpoIndices = await this.removeListTail(questionIndex, stateObject.additionalRpoIndices)
            await rpoReselectHandler(stateObject.additionalRpoQuestions, stateObject.additionalRpoIndices)
            isReselect = true
        }

        let selectIndices = stateObject.additionalRpoIndices

        isReselect ? selectIndices[selectIndices.length-1] = selectionIndex :selectIndices.push(selectionIndex)
        let composite = await  stateObject.additionalRpoQuestions[stateObject.additionalRpoQuestions.length-1]
        if(composite !== undefined){
            if(Object.keys(composite.nextOption).length === 0){
                await vinDecodeRpoHandler(selection, selectIndices, true)
            }else{
                let code = await composite.codeMap[selection]
                let nextComposite = await composite.nextOption[code]
                if(undefined === nextComposite){
                    //We are done, nothing else to render
                    await vinDecodeRpoHandler(await selection, await selectIndices, true)
                    return
                }
                let updatedComposites = await this.updateRpoComposites(nextComposite, stateObject.additionalRpoQuestions)
                let rpoLocations = await stateObject.additionalRpoLocations
                if(rpoLocations.length % 2 === 0){
                    await rpoLocations.push({
                        top: rpoLocations[rpoLocations.length - 1].top +10,
                        left: rpoLocations[rpoLocations.length - 1].left - 380
                    })
                }else{
                    await rpoLocations.push({
                        top: rpoLocations[rpoLocations.length - 1].top - 107,
                        left: rpoLocations[rpoLocations.length - 1].left + 380,
                    })
                }
                await vinDecodeRpoHandler(await selection, await selectIndices, false)
                await rpoRenderListHandler(updatedComposites, rpoLocations)
            }
        }else{
            await vinDecodeRpoHandler(await selection, await selectIndices, true)
        }
    }

    async updateWspRpoStateObjects(stateObject, selection, selectionIndex, presenterHandler, stateHandler){
        await presenterHandler()

        let postOption = await stateObject.selectedMethods[stateObject.methodIndex][1].options[0]

        let postOptionLabel = postOption.label
        let postOpCode
        if(stateObject.postRpoQuestions.length === 1){
            postOpCode = postOption.selectedCode
        }else{
            postOpCode = postOption.selections[selection]
        }

        let productionOptionContents = [postOptionLabel, postOpCode, selection]
        await stateHandler(selectionIndex, productionOptionContents)
    }
}

export default RpoService;